import {useCallback, useState} from "react";
import {getProductImagesAsync, getTheLatestProductDetailAsync} from "../../../../store/product/productSlice";
import {DisplayPosition, ProductDataState, ProductFileType, ProductImage} from "../../../../types/product";
import {useAppDispatch, useModal} from "../../../../hooks/hooks";
import {ProductSearchCondition} from "../../../../types/page";

export function useProductDetailGetter() {
    const dispatch = useAppDispatch();
    const { openAlertModal} = useModal();
    const [productData, setProductData] = useState<ProductDataState>({
        // [DisplayPosition.USER_WEB_DCAS_ADULT]: {
        //     info: undefined,
        //     images: {
        //         desktop: [],
        //         mobile: []
        //     }
        // },
        [DisplayPosition.USER_WEB_DCAS]: {
            info: undefined,
            images: {
                desktop: [],
                mobile: []
            }
        }
    });

    const getSortedImageUrls = useCallback(
        (images: ProductImage[]) =>
            images
                .sort((a, b) => a.orderNum - b.orderNum)
                .map((img) => {
                    const url = img.file.uri;
                    return {
                        type: ProductFileType.getFileTypeFromUrl(url),
                        url,
                    };
                }),
        []
    );

    /**
     * 현재 디스플레이 상품
     * 카테고리 전체 조회 후 박스 선택에 따라 상태값 처리 (API 다중요청 X)
     */
    const getProductDetail = useCallback(
        async (condition: ProductSearchCondition) => {
        try {
            // 상품 정보 API 요청
            const [/*adultResult, */teenagerResult] = await Promise.all([
                // dispatch(getTheLatestProductDetailAsync({
                //     displayPosition: DisplayPosition.USER_WEB_DCAS_ADULT,
                //     language: condition.language
                // })).unwrap(),
                dispatch(getTheLatestProductDetailAsync({
                    condition: condition,
                    displayPosition: DisplayPosition.USER_WEB_DCAS
                })).unwrap()
            ]);

            // 이미지 데이터 병렬로 가져오기
            const [/*adultImage,*/ teenImage] = await Promise.all([
                // dispatch(getProductImagesAsync({
                //     productIdx: adultResult.idx,
                //     language: condition.language,
                //     displayPosition: DisplayPosition.USER_WEB_DCAS_ADULT
                // })).unwrap(),
                dispatch(getProductImagesAsync({
                    condition: {
                        productIdx: teenagerResult.idx,
                        language: condition.language
                    },
                    displayPosition: DisplayPosition.USER_WEB_DCAS
                })).unwrap()
            ]);

            // 상태 업데이트
            setProductData({
                // [DisplayPosition.USER_WEB_DCAS_ADULT]: {
                //     info: adultResult,
                //     images: {
                //         desktop: getSortedImageUrls(adultImage.desktopImages),
                //         mobile: getSortedImageUrls(adultImage.mobileImages)
                //     }
                // },
                [DisplayPosition.USER_WEB_DCAS]: {
                    info: teenagerResult,
                    images: {
                        desktop: getSortedImageUrls(teenImage.desktopImages),
                        mobile: getSortedImageUrls(teenImage.mobileImages)
                    }
                }
            });
        } catch (error) {
            console.error(error);
            openAlertModal(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openAlertModal]);

    return {
        getProductDetail, productData
    }
}